module.exports = __webpack_public_path__ + "static/gatku-1-4fd973c1ab4b485063067808a389951e.jpg";